export { default as DetalhesTab } from './DetalhesTab';
export { default as DetalhesForm } from './DetalhesForm';
